import { useEffect, useState, useRef, useCallback   } from "react";
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEllipsisV, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalOpcoesIcone, ModalPermissoesGrupo } from '../Modais/Modal';
import { useNavigate } from 'react-router-dom';



function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length, c.length);
    }
    return null;
}

var timeout_pesquisar = null;

const Grupo = ({ tipo, filtroPesquisa, setFiltroPesquisa, showToast, grupos, setGrupos, onGrupoClick, recarregar, fetchGrupos}) => {
    const [titulo, setTitulo] = useState('');
    const [idGrupo, setIdGrupo] = useState('');
    const [imagem, setImagem] = useState('');
    const [cor, setCor] = useState('primary');
    const [isEditing, setIsEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showOpcoesIcone, setShowOpcoesIcone] = useState(false);
    const [toast, setToast] = useState({ message: '', type: '', visible: false });
    const [selectedGrupoDetalhes, setSelectedGrupoDetalhes] = useState({
        titulo: '',
        registros: [],
    });
    const [selectedGrupoOptions, setSelectedGrupoOptions] = useState(null);
    const [showGroupDetails, setShowGroupDetails] = useState(false);
    const [autorizado, setAutorizado] = useState(null);
    const optionsMenuRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {

        if(tipo === "search"){
            filtrarPalavra("")
        }
        
        const token_autorizado = getCookie("info");
    
        if (!token_autorizado) {
            alert("Você precisa estar logado para acessar esta página. Redirecionando...");
            window.location.href = "/"; 
            return;
        }
    
        setAutorizado(true);

        const handleClickOutside = (event) => {
            if (optionsMenuRef.current && !optionsMenuRef.current.contains(event.target)) {
                setSelectedGrupoOptions(null);
            }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    
    }, []); 

    // useEffect(() => {
    //     if (selectedButton === "meusGrupos") {
    //         filtrarPalavra("")
    //     }
    // }, [selectedButton, recarregar]); 

    const debounce_filtrar_palavra = (palavra) => {
        clearTimeout(timeout_pesquisar);
        setFiltroPesquisa(palavra);
        setLoading(true);

        timeout_pesquisar = setTimeout(() => {
            filtrarPalavra(palavra);
            setLoading(false);
        }, 500);
    }

    const btn_adicionar_grupo = () => { //abre o card do grupo limpo

        setIdGrupo('');
        setTitulo(''); // Limpa o título
        setImagem(''); // Limpa o ícone
        setCor('primary'); // Define uma cor padrão
        setSelectedGrupoDetalhes(null); // Limpa o grupo selecionado
        setIsEditing(false); // Define o modal para o modo de criação
        setShowModal(true); // Abre o modal    

    };

    const lista_container_meus_grupos = () => {
        return( 
            <div>
                <div className="cards">
                    {gruposOrdenados.map((grupo, index) => (
                        <div
                            key={index}
                            className="card"
                            style={{ backgroundColor: grupo.cor }}
                            onClick={() => onGrupoSelecionadoInterno(grupo)}
                        >
                            <button
                                className="options-button"
                                onClick={(e) => onOpcoesGrupo(e, grupo.id)}
                            >
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </button>
            
                            {selectedGrupoOptions === grupo.id && (
                                <div className="options-menu" ref={optionsMenuRef}>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            btn_editar_grupo(grupo.id);
                                            setSelectedGrupoOptions(null);
                                        }}
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onDeletarGrupo(grupo.id);
                                        }}
                                    >
                                        Excluir
                                    </button>
                                </div>
                            )}
                            <div className="group-text-title">
                                <FontAwesomeIcon icon={getIcon(grupo.imagem)} className="group-icon" />
                                <span className="card-title">{grupo.titulo}</span><br/>
                                <small>Responsável: {grupo.responsavel_nome}</small>           
                                <br /> 
                                <span className="card-registro">
                                    {typeof grupo.registro === 'string' && grupo.registro.trim().length > 0 ?  (
                                        grupo.registro
                                            .split(',') // Divide a string em um array de registros
                                            .slice(0, 5) // Pega os primeiros 5 registros
                                            .map((registro, registroIndex) => (
                                                <span key={registroIndex}>
                                                    {registro}
                                                    {registroIndex < 4 && ', '} {/* Adiciona vírgula entre os registros, mas não no último */}
                                                </span>
                                            ))
                                    ) : (
                                        <div>Nenhum registro</div> // Mensagem caso não seja uma string ou um array
                                    )}
                                </span>
                            </div>
                            
                        </div>
                    ))}
                </div>
                <button 
                    id="add-card-flutuante"
                    title="Cadastrar Grupo"  
                    onClick={(e) => {
                        e.stopPropagation();
                        btn_adicionar_grupo();
                        
                    }}
                >
                    +
                </button>  
            </div>
            
        );
        
    };

    const filtrarPalavra = async (palavra) => {

        try {
            const authorizationToken = getCookie("info");

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/grupos/pesquisar_palavra`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authority: authorizationToken,
                },
                body: JSON.stringify({ buscar_palavra: palavra }),
            });

            const data = await response.json();

            if (data.status === "erro") {
                alert(data.mensagem);
            } else {
                if (data.lista.length === 0){
                    showToast("Não há resultados para esta busca", "error")
                  
                }
                setGrupos(data.lista);
            }
        } catch (error) {
            console.error("Erro na busca:", error);
        } finally {
            setLoading(false);
            
        }
    };

    const btn_editar_grupo = (id_grupo) => {
        setIdGrupo(id_grupo);
        const token_autorizado = getCookie("info");

        fetch(`${process.env.REACT_APP_API_URL}/api/grupos/buscar?id=` + id_grupo, {
            method: 'GET',
            headers: {
                'Authority': token_autorizado,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then((response) => response.json())
        .then((result) => {
            if (result.status === "erro") {
                Swal.fire({
                    text: result.mensagem,
                    icon: "error"
                });
            } else {
                setIdGrupo(result.grupo["id"])
                setTitulo(result.grupo["titulo"])
                setImagem(result.grupo["imagem"])
                setCor(result.grupo["cor"])
                setSelectedGrupoDetalhes(id_grupo);
                setIsEditing(true); // Define o modal para o modo de edição
                setShowModal(true); // Abre o modal
            }
        })
        .catch((error) => {
            console.log(error);
            Swal.fire({
                title: "Ops!",
                text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                icon: "warning"
            });
        });
    };

    const abrirOpcoesIcone = () => {
        setShowOpcoesIcone(true);
    };

    const iconeSelecionado = (icon) => {
        setImagem(icon); // Atualiza o estado com o ícone selecionado
        setShowOpcoesIcone(false); // Fecha o modal de seleção de ícones
    };

    const fecharModal = () => {
        setShowModal(false);
    };

    const onDeletarGrupo = (idGrupo) => {
        //setItemToDelete({ type: 'group', id: idGrupo });
        //setShowConfirmationModal(true);

        const token_autorizado = getCookie("info");

        Swal.fire({
            title: "Você tem certeza que deseja excluir este grupo?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, excluir!"
        })
        .then((result) => {
            if (result.value) {
                fetch(`${process.env.REACT_APP_API_URL}/api/grupos/deletar`, {
                    method: 'POST',
                    headers: {
                        'Authority': token_autorizado,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "id" : idGrupo
                    })
                })
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "erro") {
                        Swal.fire({
                            text: result.mensagem,
                            icon: "error"
                        });
                    } else {
                        Swal.fire({
                                title: "Excluido!",
                                text: "Grupo excluído com sucesso.",
                                icon: "success"
                        }).then(() => {
                            filtrarPalavra(); 
                        });
                        showToast('Grupo deletado com sucesso!', 'success');
                    }
                });         
            }
            else if (result.dismiss === "cancel") {}
        }) 
        .catch((error) => {
            console.log(error);
            Swal.fire({
                title: "Ops!",
                text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                icon: "warning"
            });
        });
    };

    const salvarAlteracoesGrupo = () => {      

        if (isEditing) {

            // Modo de edição: atualiza o grupo existente
            if (!selectedGrupoDetalhes) {
                alert('Nenhum grupo selecionado para edição');
                return;
            }
            // const updatedGrupos = grupos.map(grupo =>
            //     grupo.nome === selectedGrupoDetalhes.nome
            //         ? { ...grupo, nome: titulo, icone: imagem, cor: cor }
            //         : grupo
            // );

            //setGrupos(updatedGrupos);
            const token_autorizado = getCookie("info");
    
            fetch(`${process.env.REACT_APP_API_URL}/api/grupos/atualizar`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: idGrupo,
                    titulo: titulo,
                    imagem: imagem,
                    cor: cor
                })
            })
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "erro") {
                    Swal.fire({
                        text: result.mensagem,
                        icon: "error"
                    });
                } else {
                    Swal.fire({
                        text: 'Grupo atualizado com sucesso!',
                        icon: "success"
                    }).then(() => {
                        filtrarPalavra(); // Atualiza a lista de grupos
                        setShowModal(false);
                    });
                    setShowModal(false); // Fecha o modal
                }
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    title: "Ops!",
                    text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                    icon: "warning"
                });
            });
            
        } else {
            // Modo de criação: adiciona um novo grupo

            const token_autorizado = getCookie("info");

            fetch(`${process.env.REACT_APP_API_URL}/api/grupos/cadastrar`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    titulo: titulo,
                    imagem: imagem,
                    cor: cor 
                }),
            })
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "erro") {
                    Swal.fire({
                        text: result.mensagem,
                        icon: "error"
                    });
                } else {
                    Swal.fire({
                        text: 'Grupo cadastrado com sucesso!',
                        icon: "success"
                    }).then(() => {
                        filtrarPalavra(); // Atualiza a lista de grupos
                        setShowModal(false);
                       
                    });
                    
                    setShowModal(false); // Fecha o modal
                }
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    title: "Ops!",
                    text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                    icon: "warning"
                });
            });    
        }
    
    };

    // const showToast = (message, type) => {
    //     setToast({ message, type, visible: true });
    //     setTimeout(() => {
    //         setToast({ message: '', type: '', visible: false });
    //     }, 3000); // Fecha o Toast após 3 segundos
    // };

    const getIcon = (iconName) => {
        if (typeof iconName !== 'string') return ['fas', 'th']; // Ícone padrão se não houver seleção

        const parts = iconName.split(' ');
        if (parts.length === 2) {
            return parts; // Retorna corretamente ['fas', 'star']
        }

        return ['fas', 'th']; // Ícone padrão se houver erro
    };

    const onOpcoesGrupo = (e, grupoId) => {
        e.stopPropagation(); // Impede que o clique se propague para o card
        setSelectedGrupoOptions(selectedGrupoOptions === grupoId ? null : grupoId);
    };

    const onGrupoSelecionadoInterno = (grupo) => {
        setFiltroPesquisa("");

        if (!grupo.registros) {
            grupo.registros = [];
        }
        
        onGrupoClick(grupo);
        setShowGroupDetails(true); 
    };

    const gruposOrdenados = [...grupos].sort((a, b) => a.titulo.localeCompare(b.titulo));


    return (
        <>
            {tipo === "search" && (
                <div className="search-bar-wrapper">
                    <input
                        type="text"
                        placeholder="Pesquisar grupos..."
                        value={filtroPesquisa}
                        onChange={(e) => debounce_filtrar_palavra(e.target.value)}
                        //onChange={(e) => lista_meus_grupos(e.target.value)}
                    />
                    {loading && (
                        <div className="search-spinner">
                            <FontAwesomeIcon icon={faSpinner} spin />
                        </div>
                    )}
                </div>
            )}
    
            {tipo === "central" ? lista_container_meus_grupos() : null}       

            <Modal 
                show={showModal} 
                fecharModal={fecharModal}
                salvarAlteracoesGrupo = {salvarAlteracoesGrupo}
                onClose={() => setShowModal(false)}
                grupoId={idGrupo}
                titulo={titulo} 
                setTitulo={setTitulo}
                imagem={imagem} 
                setImagem={setImagem}
                abrirOpcoesIcone={abrirOpcoesIcone}
                cor={cor} 
                setCor={setCor} 
                isEditing={isEditing}
                showToast={showToast}
                getCookie={getCookie}
                
            />

            <ModalPermissoesGrupo
                
                grupoId={idGrupo}
                showToast={showToast}
                selectedGrupoOptions={selectedGrupoOptions}
                setSelectedGrupoOptions={setSelectedGrupoOptions}
            />
            
            <ModalOpcoesIcone 
                show={showOpcoesIcone} 
                fecharModal={() => setShowOpcoesIcone(false)} 
                iconeSelecionado={iconeSelecionado} 
            />
        </>     
    );
};

export default Grupo;